import { render, staticRenderFns } from "./AssistanceType.vue?vue&type=template&id=eedde6d0&scoped=true"
import script from "./AssistanceType.vue?vue&type=script&lang=js"
export * from "./AssistanceType.vue?vue&type=script&lang=js"
import style0 from "./AssistanceType.vue?vue&type=style&index=0&id=eedde6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedde6d0",
  null
  
)

export default component.exports